import { applyAsStep2 } from "./config";
import {
  IApplicationFrontEndModel,
  IApplicationFrontEndModelStep2,
} from "../../../types";

export const validator = async ({
  values,
}: {
  values: IApplicationFrontEndModel;
}) => {
  const errors: { [key: string]: any } = { applicationFiles: {} };

  const stepName: string = applyAsStep2.stepName!;
  const stepValues = values[stepName] as IApplicationFrontEndModelStep2;

  if (
    values.injectedData.program.applicationLink &&
    (!stepValues || !stepValues.isLinkConfirmed)
  ) {
    errors.isLinkConfirmed = "Confirmation is required";
  }

  values.injectedData.program.applicationForms.forEach((form) => {
    if (!stepValues?.applicationFiles?.hasOwnProperty(form.id)) {
      errors.applicationFiles[form.id] = "File is required";
    }
  });

  if (
    Object.keys(errors).length > 1 ||
    Object.keys(errors.applicationFiles).length > 0
  ) {
    throw {
      [stepName]: errors,
    };
  }
};
